import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, CurrencyProvider, useAuth } from "./lib/contexts";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import Deals from "./pages/Deals";
import Reports from "./pages/Reports";
import GrabADeal from "./pages/GrabADeal";
import ManageFields from "./pages/ManageFields";
import ManageUsers from "./pages/ManageUsers";
import ManageProducts from "./pages/ManageProducts";
import AccountSettings from "./pages/AccountSettings";
import ResetPassword from "./pages/ResetPassword";
import Layout from "./components/Layout";
import "./App.css";

function Protected({ children, managerOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (managerOnly && user.role !== "manager") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
            <Route path="/deals" element={<Protected><Deals /></Protected>} />
            <Route path="/grab-a-deal" element={<Protected><GrabADeal /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/settings/account" element={<Protected><AccountSettings /></Protected>} />
            <Route path="/settings/users" element={<Protected managerOnly><ManageUsers /></Protected>} />
            <Route path="/settings/products" element={<Protected managerOnly><ManageProducts /></Protected>} />
            <Route path="/settings/fields" element={<Protected managerOnly><ManageFields /></Protected>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}
